(() => {
  const ROOT_SELECTOR = "[data-pfm-root]";
  const ITEM_SELECTOR = "[data-pfm-item]";
  const TOGGLE_SELECTOR = "[data-pfm-toggle]";
  const TOGGLE_LABEL_SELECTOR = "[data-pfm-toggle-label]";
  const HIDDEN_CLASS = "is-hidden";

  function getInitialVisibleCount(items) {
    if (!items.length) return 0;

    const sampleItem = items[0];
    const itemStyles = window.getComputedStyle(sampleItem);
    const marginTop = Number.parseFloat(itemStyles.marginTop) || 0;
    const marginBottom = Number.parseFloat(itemStyles.marginBottom) || 0;
    const measuredHeight = sampleItem.getBoundingClientRect().height + marginTop + marginBottom;
    const rowHeight = measuredHeight > 0 ? measuredHeight : 56;

    const viewportRows = Math.floor((window.innerHeight * 0.45) / rowHeight);
    const breakpointBonus = window.matchMedia("(min-width: 1200px)").matches
      ? 2
      : window.matchMedia("(min-width: 990px)").matches
        ? 1
        : 0;

    const visibleCount = Math.max(3, viewportRows + breakpointBonus);
    return Math.min(items.length, visibleCount);
  }

  function initFeaturesRoot(root) {
    if (!root || root.dataset.pfmInitialized === "true") return;

    const items = Array.from(root.querySelectorAll(ITEM_SELECTOR));
    const toggleButton = root.querySelector(TOGGLE_SELECTOR);

    if (!items.length || !toggleButton) {
      root.dataset.pfmInitialized = "true";
      return;
    }

    const labelNode = toggleButton.querySelector(TOGGLE_LABEL_SELECTOR);
    const viewAllLabel = toggleButton.dataset.viewAllLabel || "View all";
    const viewLessLabel = toggleButton.dataset.viewLessLabel || "View less";

    const state = {
      expanded: false,
      initialVisible: items.length,
    };

    const updateRows = () => {
      items.forEach((item, index) => {
        const hidden = !state.expanded && index >= state.initialVisible;
        item.classList.toggle(HIDDEN_CLASS, hidden);
        item.setAttribute("aria-hidden", String(hidden));
      });

      toggleButton.setAttribute("aria-expanded", String(state.expanded));
      const nextLabel = state.expanded ? viewLessLabel : viewAllLabel;
      if (labelNode) {
        labelNode.textContent = nextLabel;
      } else {
        toggleButton.textContent = nextLabel;
      }
    };

    const recalculateVisibility = () => {
      state.initialVisible = getInitialVisibleCount(items);
      const hasHiddenItems = items.length > state.initialVisible;

      toggleButton.classList.toggle(HIDDEN_CLASS, !hasHiddenItems);
      if (!hasHiddenItems) {
        state.expanded = false;
      }

      updateRows();
    };

    toggleButton.addEventListener("click", () => {
      state.expanded = !state.expanded;
      updateRows();
    });

    let resizeTimer = null;
    const handleResize = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(recalculateVisibility, 150);
    };

    window.addEventListener("resize", handleResize);
    root.__pfmCleanup = () => {
      window.removeEventListener("resize", handleResize);
      window.clearTimeout(resizeTimer);
    };

    recalculateVisibility();
    root.dataset.pfmInitialized = "true";
  }

  function initWithin(container) {
    if (!container || typeof container.querySelectorAll !== "function") return;
    container.querySelectorAll(ROOT_SELECTOR).forEach(initFeaturesRoot);
  }

  function initialize() {
    initWithin(document);

    document.addEventListener("shopify:section:load", (event) => {
      initWithin(event.target);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      event.target.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
        if (typeof root.__pfmCleanup === "function") {
          root.__pfmCleanup();
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
